import React from 'react';
import PropTypes from 'prop-types';

export const IconArrow = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 6.058 10.72"
  >
    <path
      d="M10.023,6.058,5.36,1.395.7,6.058l-.7-.7L5.36,0l5.36,5.361Z"
      transform="translate(6.058) rotate(90)"
    />
  </svg>
);

IconArrow.propTypes = {
  className: PropTypes.string,
};

IconArrow.defaultProps = {
  className: '',
};
